import Product from './Product';
import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import { localiseUrl } from 'src/common/utils/format-localised-url';
import { withModel } from '../../../data-providers/model';

const enhance = compose(
  withModel,
  mapProps(props => {
    const slug = props.slug || props.productSlug || '';
    return {
      ...props,
      link: localiseUrl(props.model.countryModel, `/personalized-products/${slug}`),
    };
  }),
);

export default enhance(Product);



// WEBPACK FOOTER //
// ./src/client/js/view/components/RelatedProducts/Product/index.js